/**
 * @generated SignedSource<<4a2b8b49f191d46a365a1514e43a7886>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs, Result } from "relay-runtime";
export type VotableOrder = "HOT" | "NEWEST" | "OLDEST";
export type TopicPageQuery$variables = {
  id: string;
  order: VotableOrder;
};
export type TopicPageQuery$data = {
  readonly node: Result<{
    readonly __typename: "Topic";
    readonly " $fragmentSpreads": FragmentRefs<"TopicPageFragment">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }, unknown>;
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"TopicCommentsFormViewerFragment">;
  };
};
export type TopicPageQuery = {
  response: TopicPageQuery$data;
  variables: TopicPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*:: as any*/),
    (v4/*:: as any*/)
  ],
  "type": "Entity",
  "abstractKey": "__isEntity"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v11 = [
  (v2/*:: as any*/),
  (v10/*:: as any*/),
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isEntity"
  },
  (v3/*:: as any*/),
  (v4/*:: as any*/),
  (v6/*:: as any*/)
],
v12 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v13 = [
  (v12/*:: as any*/),
  {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hotness",
  "storageKey": null
},
v16 = {
  "alias": "viewerCanDelete",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "DELETE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"DELETE_COMMENT\")"
},
v17 = {
  "alias": "viewerCanUpdate",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "UPDATE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"UPDATE_COMMENT\")"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "edited",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topic",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Forum",
      "kind": "LinkedField",
      "name": "forum",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v6/*:: as any*/)
          ],
          "storageKey": null
        },
        (v6/*:: as any*/)
      ],
      "storageKey": null
    },
    (v6/*:: as any*/)
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Comment",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": [
    (v6/*:: as any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v6/*:: as any*/),
    (v10/*:: as any*/),
    (v5/*:: as any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": "viewerCanReply",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "CREATE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"CREATE_COMMENT\")"
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votes",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "voterCount",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": [
    (v12/*:: as any*/)
  ],
  "concreteType": "VotersConnection",
  "kind": "LinkedField",
  "name": "voters",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EntityEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v11/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "voters(first:10)"
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "EntityVote",
  "kind": "LinkedField",
  "name": "voted",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "score",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v28 = {
  "alias": "viewerCanVote",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "PUBLISH_VOTE"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"PUBLISH_VOTE\")"
},
v29 = {
  "kind": "InlineFragment",
  "selections": [
    (v24/*:: as any*/),
    (v25/*:: as any*/),
    (v26/*:: as any*/),
    (v27/*:: as any*/),
    (v28/*:: as any*/)
  ],
  "type": "Votable",
  "abstractKey": "__isVotable"
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v31 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v32 = [
  "order"
],
v33 = {
  "alias": null,
  "args": (v13/*:: as any*/),
  "filters": (v32/*:: as any*/),
  "handle": "connection",
  "key": "CommentCommentsFragment_children",
  "kind": "LinkedHandle",
  "name": "children"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TopicPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TopicCommentsFormViewerFragment"
          }
        ],
        "storageKey": null
      },
      {
        "kind": "CatchField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v2/*:: as any*/),
              "action": "THROW"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TopicPageFragment"
                }
              ],
              "type": "Topic",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        "to": "RESULT"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "TopicPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*:: as any*/)
            ],
            "type": "User",
            "abstractKey": null
          },
          (v6/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v6/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              (v8/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Forum",
                "kind": "LinkedField",
                "name": "forum",
                "plural": false,
                "selections": [
                  (v9/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      (v9/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "forumOwnerKind",
                        "storageKey": null
                      },
                      (v6/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*:: as any*/),
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": (v11/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": "viewerCanEdit",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "UPDATE_TOPIC"
                  }
                ],
                "kind": "ScalarField",
                "name": "viewerCan",
                "storageKey": "viewerCan(action:\"UPDATE_TOPIC\")"
              },
              {
                "alias": "viewerCanDelete",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "DELETE_TOPIC"
                  }
                ],
                "kind": "ScalarField",
                "name": "viewerCan",
                "storageKey": "viewerCan(action:\"DELETE_TOPIC\")"
              },
              {
                "alias": null,
                "args": (v13/*:: as any*/),
                "concreteType": "CommentConnection",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CommentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v14/*:: as any*/),
                      (v15/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*:: as any*/),
                          (v16/*:: as any*/),
                          (v17/*:: as any*/),
                          (v18/*:: as any*/),
                          (v19/*:: as any*/),
                          (v8/*:: as any*/),
                          (v20/*:: as any*/),
                          (v21/*:: as any*/),
                          (v22/*:: as any*/),
                          (v23/*:: as any*/),
                          {
                            "alias": null,
                            "args": (v13/*:: as any*/),
                            "concreteType": "CommentConnection",
                            "kind": "LinkedField",
                            "name": "children",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CommentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v14/*:: as any*/),
                                  (v15/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v6/*:: as any*/),
                                      (v16/*:: as any*/),
                                      (v17/*:: as any*/),
                                      (v18/*:: as any*/),
                                      (v19/*:: as any*/),
                                      (v8/*:: as any*/),
                                      (v20/*:: as any*/),
                                      (v21/*:: as any*/),
                                      (v22/*:: as any*/),
                                      (v23/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": (v13/*:: as any*/),
                                        "concreteType": "CommentConnection",
                                        "kind": "LinkedField",
                                        "name": "children",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CommentEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              (v14/*:: as any*/),
                                              (v15/*:: as any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Comment",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v6/*:: as any*/),
                                                  (v16/*:: as any*/),
                                                  (v17/*:: as any*/),
                                                  (v18/*:: as any*/),
                                                  (v19/*:: as any*/),
                                                  (v8/*:: as any*/),
                                                  (v20/*:: as any*/),
                                                  (v21/*:: as any*/),
                                                  (v22/*:: as any*/),
                                                  (v23/*:: as any*/),
                                                  {
                                                    "alias": null,
                                                    "args": (v13/*:: as any*/),
                                                    "concreteType": "CommentConnection",
                                                    "kind": "LinkedField",
                                                    "name": "children",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "CommentEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          (v14/*:: as any*/),
                                                          (v15/*:: as any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Comment",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v6/*:: as any*/),
                                                              (v16/*:: as any*/),
                                                              (v17/*:: as any*/),
                                                              (v18/*:: as any*/),
                                                              (v19/*:: as any*/),
                                                              (v8/*:: as any*/),
                                                              (v20/*:: as any*/),
                                                              (v21/*:: as any*/),
                                                              (v22/*:: as any*/),
                                                              (v23/*:: as any*/),
                                                              {
                                                                "alias": null,
                                                                "args": (v13/*:: as any*/),
                                                                "concreteType": "CommentConnection",
                                                                "kind": "LinkedField",
                                                                "name": "children",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "CommentEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      (v14/*:: as any*/),
                                                                      (v15/*:: as any*/),
                                                                      {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "Comment",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v6/*:: as any*/),
                                                                          (v16/*:: as any*/),
                                                                          (v17/*:: as any*/),
                                                                          (v18/*:: as any*/),
                                                                          (v19/*:: as any*/),
                                                                          (v8/*:: as any*/),
                                                                          (v20/*:: as any*/),
                                                                          (v21/*:: as any*/),
                                                                          (v22/*:: as any*/),
                                                                          (v23/*:: as any*/),
                                                                          {
                                                                            "alias": null,
                                                                            "args": (v13/*:: as any*/),
                                                                            "concreteType": "CommentConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "children",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "CommentEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                  (v14/*:: as any*/),
                                                                                  (v15/*:: as any*/),
                                                                                  {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Comment",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                      (v6/*:: as any*/),
                                                                                      (v16/*:: as any*/),
                                                                                      (v17/*:: as any*/),
                                                                                      (v18/*:: as any*/),
                                                                                      (v19/*:: as any*/),
                                                                                      (v8/*:: as any*/),
                                                                                      (v20/*:: as any*/),
                                                                                      (v21/*:: as any*/),
                                                                                      (v22/*:: as any*/),
                                                                                      (v23/*:: as any*/),
                                                                                      {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "kind": "ScalarField",
                                                                                        "name": "numChildren",
                                                                                        "storageKey": null
                                                                                      },
                                                                                      (v2/*:: as any*/),
                                                                                      (v29/*:: as any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                  }
                                                                                ],
                                                                                "storageKey": null
                                                                              },
                                                                              (v30/*:: as any*/),
                                                                              (v31/*:: as any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                          },
                                                                          (v33/*:: as any*/),
                                                                          (v2/*:: as any*/),
                                                                          (v29/*:: as any*/)
                                                                        ],
                                                                        "storageKey": null
                                                                      }
                                                                    ],
                                                                    "storageKey": null
                                                                  },
                                                                  (v30/*:: as any*/),
                                                                  (v31/*:: as any*/)
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              (v33/*:: as any*/),
                                                              (v2/*:: as any*/),
                                                              (v29/*:: as any*/)
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v30/*:: as any*/),
                                                      (v31/*:: as any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v33/*:: as any*/),
                                                  (v2/*:: as any*/),
                                                  (v29/*:: as any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v30/*:: as any*/),
                                          (v31/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v33/*:: as any*/),
                                      (v2/*:: as any*/),
                                      (v29/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v30/*:: as any*/),
                              (v31/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v33/*:: as any*/),
                          (v2/*:: as any*/),
                          (v29/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v30/*:: as any*/),
                  (v31/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v13/*:: as any*/),
                "filters": (v32/*:: as any*/),
                "handle": "connection",
                "key": "TopicCommentsFragment_comments",
                "kind": "LinkedHandle",
                "name": "comments"
              },
              (v24/*:: as any*/),
              {
                "alias": "lastComments",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "last",
                    "value": 10
                  }
                ],
                "concreteType": "CommentConnection",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v18/*:: as any*/),
                      (v8/*:: as any*/),
                      (v24/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          (v10/*:: as any*/),
                          (v3/*:: as any*/),
                          (v6/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "comments(last:10)"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v25/*:: as any*/),
                  (v26/*:: as any*/),
                  (v27/*:: as any*/),
                  (v28/*:: as any*/)
                ],
                "type": "Votable",
                "abstractKey": "__isVotable"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "viewerCanSubscribe",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "action",
                        "value": "CREATE_SUBJECT_SUBSCRIPTION"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "viewerCan",
                    "storageKey": "viewerCan(action:\"CREATE_SUBJECT_SUBSCRIPTION\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "entitySubscription",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      (v6/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "kind",
                        "storageKey": null
                      },
                      {
                        "alias": "viewerCanUnsubscribe",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "action",
                            "value": "DELETE_SUBJECT_SUBSCRIPTION"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "viewerCan",
                        "storageKey": "viewerCan(action:\"DELETE_SUBJECT_SUBSCRIPTION\")"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Subscribable",
                "abstractKey": "__isSubscribable"
              },
              (v31/*:: as any*/)
            ],
            "type": "Topic",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1c685f4cd306ca8d75bd2c83dbb0b1b9",
    "id": null,
    "metadata": {},
    "name": "TopicPageQuery",
    "operationKind": "query",
    "text": "query TopicPageQuery(\n  $id: ID!\n  $order: VotableOrder!\n) {\n  viewer @ifAllowed {\n    __typename\n    ...TopicCommentsFormViewerFragment\n    id\n  }\n  node(id: $id) {\n    __typename\n    ... on Topic {\n      ...TopicPageFragment\n    }\n    id\n  }\n}\n\nfragment CommentCommentsFragment_1CbDfQ on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_3zZj4p\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_28oB9U on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_4kTGy2\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_3zZj4p on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_4hzBTb\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_4hzBTb on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_2rOHm3\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_4kTGy2 on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_1CbDfQ\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentDeleteFragment on Comment {\n  id\n  author {\n    id\n  }\n  topic {\n    id\n  }\n  parent {\n    id\n  }\n}\n\nfragment CommentDisplayFragment on Comment {\n  viewerCanDelete: viewerCan(action: DELETE_COMMENT)\n  viewerCanUpdate: viewerCan(action: UPDATE_COMMENT)\n  id\n  content\n  edited\n  createdAt\n  topic {\n    forum {\n      owner {\n        __typename\n        id\n      }\n      id\n    }\n    id\n  }\n  parent {\n    id\n  }\n  ...CommentDeleteFragment\n  author {\n    id\n    username\n    ...EntityProfilePicFragment_49kWkb\n  }\n  ...VoteDisplayFragment\n}\n\nfragment CommentFragment_1CbDfQ on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_1CbDfQ\n}\n\nfragment CommentFragment_28oB9U on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_28oB9U\n}\n\nfragment CommentFragment_2rOHm3 on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  numChildren\n}\n\nfragment CommentFragment_3zZj4p on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_3zZj4p\n}\n\nfragment CommentFragment_4hzBTb on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_4hzBTb\n}\n\nfragment CommentFragment_4kTGy2 on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_4kTGy2\n}\n\nfragment CommentReplyFragment on Comment {\n  id\n  viewerCanReply: viewerCan(action: CREATE_COMMENT)\n  topic {\n    forum {\n      owner {\n        __typename\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment EntitiesAvatarFragment on VotersConnection {\n  edges {\n    node {\n      __typename\n      username\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment SubjectSubscriptionButtonFragment on Subscribable {\n  __isSubscribable: __typename\n  id\n  viewerCanSubscribe: viewerCan(action: CREATE_SUBJECT_SUBSCRIPTION)\n  entitySubscription @ifAllowed {\n    __typename\n    id\n    kind\n    viewerCanUnsubscribe: viewerCan(action: DELETE_SUBJECT_SUBSCRIPTION)\n  }\n}\n\nfragment TopicCommentsFormTopicFragment on Topic {\n  id\n  forum {\n    owner {\n      __typename\n      id\n    }\n    id\n  }\n}\n\nfragment TopicCommentsFormViewerFragment on User {\n  ...EntityProfilePicFragment_49kWkb\n}\n\nfragment TopicCommentsFragment_17VYVu on Topic {\n  comments(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_28oB9U\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment TopicDeleteButtonFragment on Topic {\n  id\n  title\n  forum {\n    id\n    slug\n    owner {\n      __typename\n      slug\n      forumOwnerKind\n      id\n    }\n  }\n}\n\nfragment TopicHelmetFragment on Topic {\n  id\n  title\n  description\n  createdAt\n  votes\n  author {\n    __typename\n    username\n    displayName\n    id\n  }\n  forum {\n    title\n    slug\n    owner {\n      __typename\n      slug\n      forumOwnerKind\n      id\n    }\n    id\n  }\n  lastComments: comments(last: 10) {\n    nodes {\n      content\n      createdAt\n      votes\n      author {\n        username\n        displayName\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment TopicLinkFragment on Topic {\n  id\n  title\n  forum {\n    slug\n    owner {\n      __typename\n      slug\n      forumOwnerKind\n      id\n    }\n    id\n  }\n}\n\nfragment TopicPageFragment on Topic {\n  id\n  title\n  url\n  createdAt\n  forum {\n    slug\n    owner {\n      __typename\n      slug\n      forumOwnerKind\n      id\n    }\n    id\n  }\n  author {\n    __typename\n    username\n    ...EntityProfilePicFragment_49kWkb\n    id\n  }\n  description\n  viewerCanEdit: viewerCan(action: UPDATE_TOPIC)\n  viewerCanDelete: viewerCan(action: DELETE_TOPIC)\n  ...TopicCommentsFormTopicFragment\n  ...TopicCommentsFragment_17VYVu\n  ...VoteDisplayFragment\n  ...SubjectSubscriptionButtonFragment\n  ...TopicHelmetFragment\n  ...TopicLinkFragment\n  ...TopicDeleteButtonFragment\n}\n\nfragment VoteDisplayFragment on Votable {\n  __isVotable: __typename\n  id\n  votes\n  voterCount\n  voters(first: 10) {\n    ...EntitiesAvatarFragment\n  }\n  voted @ifAllowed {\n    score\n  }\n  viewerCanVote: viewerCan(action: PUBLISH_VOTE)\n}\n"
  }
};
})();

(node as any).hash = "9e221f680603dfa9428c0a294c877a27";

export default node;
